import { showDialog } from '@/shared/sweetAlerts/showDialog'
import DicomPlusMixin from '@/shared/mixins/dicom-plus.mixin'

export default {
  mixins: [DicomPlusMixin],
  name: 'x-plus-cancelamento',
  props: {
    dicomPlusID: {
      type: Number,
      required: true
    },
    MotivoCancelamento: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      MAX_COMMENT_BYTES: 500,
      currentCharCount: 0,
      isCommentOverflow: false,
      exceededChars: 0,
      maxCommentChars: 500
    }
  },
  computed: {
    localMotivoCancelamento: {
      get() {
        return this.MotivoCancelamento
      },
      set(value) {
        this.$emit('update:MotivoCancelamento', value)
      }
    }
  },
  methods: {
    async confirmarCancelarExame() {
        await showDialog({
          title: this.$t('x_plus.dialog_message.confirmation'),
          text: this.$t('x_plus.dialog_message.confirm_to_cancel'),
          confirmButtonText: this.$t('x_plus.yes'),
          denyButtonText: this.$t('x_plus.no'),
          icon: "question",
          focusConfirm: false,
          focusDeny: true,
          confirmed: this.cancelarXPlus
        })
    },
    async cancelarXPlus(){
      this.$root.$emit('showLoading');
      try {
        await this.cancelDicomPlus(this.dicomPlusID, this.localMotivoCancelamento);
        showDialog({
          icon: 'success',
          title: this.$t('x_plus.dialog_message.success'),
          text:  this.$t('x_plus.dialog_message.canceled_successfully'),
          confirmButtonText: 'Ok',
          confirmed: this.closeModal
        })
      } catch (error) {
        const errorMessage = error.response?.data?.errors || error.message || this.$t('x_plus.dialog_message.unknown_error');
        const isAvailableError = errorMessage.includes('disponível');

        showDialog({
            icon: isAvailableError ? 'warning' : 'error',
            title: isAvailableError ? this.$t('x_plus.dialog_message.warn') : this.$t('x_plus.dialog_message.error'),
            text: errorMessage,
            confirmButtonText: 'Ok',
          })
      } finally {
        this.$root.$emit('hideLoading');
      }
    },
    handleCancelamento() {
      if (this.isCommentOverflow) {
        return;
      }

      this.confirmarCancelarExame()
    },
    onComentarioInput() {
      if (!this.localMotivoCancelamento) {
        this.isCommentOverflow = false
        this.currentCharCount = 0
        this.exceededChars = 0
        return
      }

      const byteLength = new TextEncoder().encode(this.localMotivoCancelamento).length

      this.currentCharCount = byteLength

      this.isCommentOverflow = byteLength > this.MAX_COMMENT_BYTES

      this.exceededChars = this.isCommentOverflow
        ? byteLength - this.MAX_COMMENT_BYTES
        : 0
    },
    onComentarioBlur() {
      if (this.localMotivoCancelamento) {

        const byteLength = new TextEncoder().encode(this.localMotivoCancelamento).length
        this.currentCharCount = byteLength
        this.isCommentOverflow = byteLength > this.MAX_COMMENT_BYTES
        this.exceededChars = this.isCommentOverflow
          ? byteLength - this.MAX_COMMENT_BYTES
          : 0
      }
    },
    closeModal() {
      this.$emit('close');
      this.$emit('refreshGrid');
      this.localMotivoCancelamento = '';
    },

  }
}
